import { createSelector } from 'reselect';
import { mapWithDefault } from '../../../utils/dataMapper';

const selectStandardVTCMedicalBenefitsTugo = (state) => state.get('standardVTCMedicalBenefitsTugo');

const makeSelectStandardVTCMedicalBenefitsTugo = () => createSelector(
  selectStandardVTCMedicalBenefitsTugo,
  (standardVTCMedicalBenefitsTugoState) => ({

    whatExpensesAreYouClaimingFor: mapWithDefault(
      standardVTCMedicalBenefitsTugoState,
      () => standardVTCMedicalBenefitsTugoState.getIn(['form', 'whatExpensesAreYouClaimingFor']),
      []
    ),

    // Doctor Visit selectors
    doctorVisitTelemedicine: mapWithDefault(
      standardVTCMedicalBenefitsTugoState,
      () => standardVTCMedicalBenefitsTugoState.getIn(['form', 'doctorVisitTelemedicine']),
      ''
    ),
    doctorVisitFirstVisit: mapWithDefault(
      standardVTCMedicalBenefitsTugoState,
      () => standardVTCMedicalBenefitsTugoState.getIn(['form', 'doctorVisitFirstVisit']),
      ''
    ),
    doctorVisitFollowUp: mapWithDefault(
      standardVTCMedicalBenefitsTugoState,
      () => standardVTCMedicalBenefitsTugoState.getIn(['form', 'doctorVisitFollowUp']),
      ''
    ),
    infoOutpatientPhysicianFeesItems: mapWithDefault(
      standardVTCMedicalBenefitsTugoState,
      () => standardVTCMedicalBenefitsTugoState.getIn(['form', 'infoOutpatientPhysicianFeesItems']),
      []
    ),
    infoFollowUpVisitItems: mapWithDefault(
      standardVTCMedicalBenefitsTugoState,
      () => standardVTCMedicalBenefitsTugoState.getIn(['form', 'infoFollowUpVisitItems']),
      []
    ),
    infoTelemedicineItems: mapWithDefault(
      standardVTCMedicalBenefitsTugoState,
      () => standardVTCMedicalBenefitsTugoState.getIn(['form', 'infoTelemedicineItems']),
      []
    ),
    doctorVisitFollowUpFracture: mapWithDefault(
      standardVTCMedicalBenefitsTugoState,
      () => standardVTCMedicalBenefitsTugoState.getIn(['form', 'doctorVisitFollowUpFracture']),
      ''
    ),
    infoFollowUpFractureItems: mapWithDefault(
      standardVTCMedicalBenefitsTugoState,
      () => standardVTCMedicalBenefitsTugoState.getIn(['form', 'infoFollowUpFractureItems']),
      []
    ),

    // Diagnostic Tests
    infoDiagnosticTestsItems: mapWithDefault(
      standardVTCMedicalBenefitsTugoState,
      () => standardVTCMedicalBenefitsTugoState.getIn(['form', 'infoDiagnosticTestsItems']),
      []
    ),

    // Prescription Drugs
    infoPrescriptionDrugsItems: mapWithDefault(
      standardVTCMedicalBenefitsTugoState,
      () => standardVTCMedicalBenefitsTugoState.getIn(['form', 'infoPrescriptionDrugsItems']),
      []
    ),

    // Ambulance Services
    ambulanceGroundService: mapWithDefault(
      standardVTCMedicalBenefitsTugoState,
      () => standardVTCMedicalBenefitsTugoState.getIn(['form', 'ambulanceGroundService']),
      ''
    ),
    ambulanceAirService: mapWithDefault(
      standardVTCMedicalBenefitsTugoState,
      () => standardVTCMedicalBenefitsTugoState.getIn(['form', 'ambulanceAirService']),
      ''
    ),
    infoGroundAmbulanceItems: mapWithDefault(
      standardVTCMedicalBenefitsTugoState,
      () => standardVTCMedicalBenefitsTugoState.getIn(['form', 'infoGroundAmbulanceItems']),
      []
    ),
    infoAirAmbulanceItems: mapWithDefault(
      standardVTCMedicalBenefitsTugoState,
      () => standardVTCMedicalBenefitsTugoState.getIn(['form', 'infoAirAmbulanceItems']),
      []
    ),
    infoOtherAmbulanceItems: mapWithDefault(
      standardVTCMedicalBenefitsTugoState,
      () => standardVTCMedicalBenefitsTugoState.getIn(['form', 'infoOtherAmbulanceItems']),
      []
    ),

    // Hospitalization
    hospitalizationHospitalFees: mapWithDefault(
      standardVTCMedicalBenefitsTugoState,
      () => standardVTCMedicalBenefitsTugoState.getIn(['form', 'hospitalizationHospitalFees']),
      false
    ),
    hospitalizationInpatientPhysicianFees: mapWithDefault(
      standardVTCMedicalBenefitsTugoState,
      () => standardVTCMedicalBenefitsTugoState.getIn(['form', 'hospitalizationInpatientPhysicianFees']),
      false
    ),
    hospitalizationXrayLabsDiagnostics: mapWithDefault(
      standardVTCMedicalBenefitsTugoState,
      () => standardVTCMedicalBenefitsTugoState.getIn(['form', 'hospitalizationXrayLabsDiagnostics']),
      false
    ),
    hospitalizationEmergencyAirTransportation: mapWithDefault(
      standardVTCMedicalBenefitsTugoState,
      () => standardVTCMedicalBenefitsTugoState.getIn(['form', 'hospitalizationEmergencyAirTransportation']),
      false
    ),
    hospitalizationAirfareReturnHome: mapWithDefault(
      standardVTCMedicalBenefitsTugoState,
      () => standardVTCMedicalBenefitsTugoState.getIn(['form', 'hospitalizationAirfareReturnHome']),
      false
    ),
    hospitalizationFamilyTransportation: mapWithDefault(
      standardVTCMedicalBenefitsTugoState,
      () => standardVTCMedicalBenefitsTugoState.getIn(['form', 'hospitalizationFamilyTransportation']),
      false
    ),
    hospitalizationFamilyTransportationMealsAccommodation: mapWithDefault(
      standardVTCMedicalBenefitsTugoState,
      () => standardVTCMedicalBenefitsTugoState.getIn(['form', 'hospitalizationFamilyTransportationMealsAccommodation']),
      false
    ),
    hospitalizationMedicalAttendant: mapWithDefault(
      standardVTCMedicalBenefitsTugoState,
      () => standardVTCMedicalBenefitsTugoState.getIn(['form', 'hospitalizationMedicalAttendant']),
      false
    ),
    hospitalizationReturnOfTravellingCompanion: mapWithDefault(
      standardVTCMedicalBenefitsTugoState,
      () => standardVTCMedicalBenefitsTugoState.getIn(['form', 'hospitalizationReturnOfTravellingCompanion']),
      false
    ),
    hospitalizationReturnOfDependentChildren: mapWithDefault(
      standardVTCMedicalBenefitsTugoState,
      () => standardVTCMedicalBenefitsTugoState.getIn(['form', 'hospitalizationReturnOfDependentChildren']),
      false
    ),
    hospitalizationHospitalAllowance: mapWithDefault(
      standardVTCMedicalBenefitsTugoState,
      () => standardVTCMedicalBenefitsTugoState.getIn(['form', 'hospitalizationHospitalAllowance']),
      false
    ),
    hospitalizationOutOfPocketExpenses: mapWithDefault(
      standardVTCMedicalBenefitsTugoState,
      () => standardVTCMedicalBenefitsTugoState.getIn(['form', 'hospitalizationOutOfPocketExpenses']),
      false
    ),
    hospitalizationChildcare: mapWithDefault(
      standardVTCMedicalBenefitsTugoState,
      () => standardVTCMedicalBenefitsTugoState.getIn(['form', 'hospitalizationChildcare']),
      false
    ),
    hospitalizationReturnOfVehicle: mapWithDefault(
      standardVTCMedicalBenefitsTugoState,
      () => standardVTCMedicalBenefitsTugoState.getIn(['form', 'hospitalizationReturnOfVehicle']),
      false
    ),
    hospitalizationOtherRelated: mapWithDefault(
      standardVTCMedicalBenefitsTugoState,
      () => standardVTCMedicalBenefitsTugoState.getIn(['form', 'hospitalizationOtherRelated']),
      false
    ),
    infoHospitalFeesItems: mapWithDefault(
      standardVTCMedicalBenefitsTugoState,
      () => standardVTCMedicalBenefitsTugoState.getIn(['form', 'infoHospitalFeesItems']),
      []
    ),
    infoInpatientPhysicianFeesItems: mapWithDefault(
      standardVTCMedicalBenefitsTugoState,
      () => standardVTCMedicalBenefitsTugoState.getIn(['form', 'infoInpatientPhysicianFeesItems']),
      []
    ),
    infoXrayLabsDiagnosticsItems: mapWithDefault(
      standardVTCMedicalBenefitsTugoState,
      () => standardVTCMedicalBenefitsTugoState.getIn(['form', 'infoXrayLabsDiagnosticsItems']),
      []
    ),
    infoEmergencyAirTransportationItems: mapWithDefault(
      standardVTCMedicalBenefitsTugoState,
      () => standardVTCMedicalBenefitsTugoState.getIn(['form', 'infoEmergencyAirTransportationItems']),
      []
    ),
    infoAirfareReturnHomeItems: mapWithDefault(
      standardVTCMedicalBenefitsTugoState,
      () => standardVTCMedicalBenefitsTugoState.getIn(['form', 'infoAirfareReturnHomeItems']),
      []
    ),
    infoFamilyTransportationItems: mapWithDefault(
      standardVTCMedicalBenefitsTugoState,
      () => standardVTCMedicalBenefitsTugoState.getIn(['form', 'infoFamilyTransportationItems']),
      []
    ),
    infoFamilyTransportationMealsAccommodationItems: mapWithDefault(
      standardVTCMedicalBenefitsTugoState,
      () => standardVTCMedicalBenefitsTugoState.getIn(['form', 'infoFamilyTransportationMealsAccommodationItems']),
      []
    ),
    infoMedicalAttendantItems: mapWithDefault(
      standardVTCMedicalBenefitsTugoState,
      () => standardVTCMedicalBenefitsTugoState.getIn(['form', 'infoMedicalAttendantItems']),
      []
    ),
    infoReturnOfTravellingCompanionItems: mapWithDefault(
      standardVTCMedicalBenefitsTugoState,
      () => standardVTCMedicalBenefitsTugoState.getIn(['form', 'infoReturnOfTravellingCompanionItems']),
      []
    ),
    infoReturnOfDependentChildrenItems: mapWithDefault(
      standardVTCMedicalBenefitsTugoState,
      () => standardVTCMedicalBenefitsTugoState.getIn(['form', 'infoReturnOfDependentChildrenItems']),
      []
    ),
    infoHospitalAllowanceItems: mapWithDefault(
      standardVTCMedicalBenefitsTugoState,
      () => standardVTCMedicalBenefitsTugoState.getIn(['form', 'infoHospitalAllowanceItems']),
      []
    ),
    infoOutOfPocketExpensesItems: mapWithDefault(
      standardVTCMedicalBenefitsTugoState,
      () => standardVTCMedicalBenefitsTugoState.getIn(['form', 'infoOutOfPocketExpensesItems']),
      []
    ),
    infoChildcareItems: mapWithDefault(
      standardVTCMedicalBenefitsTugoState,
      () => standardVTCMedicalBenefitsTugoState.getIn(['form', 'infoChildcareItems']),
      []
    ),
    infoReturnOfVehicleItems: mapWithDefault(
      standardVTCMedicalBenefitsTugoState,
      () => standardVTCMedicalBenefitsTugoState.getIn(['form', 'infoReturnOfVehicleItems']),
      []
    ),
    infoOtherHospitalizationItems: mapWithDefault(
      standardVTCMedicalBenefitsTugoState,
      () => standardVTCMedicalBenefitsTugoState.getIn(['form', 'infoOtherHospitalizationItems']),
      []
    ),

    // Essential Medical Equipment
    infoEssentialMedicalEquipmentItems: mapWithDefault(
      standardVTCMedicalBenefitsTugoState,
      () => standardVTCMedicalBenefitsTugoState.getIn(['form', 'infoEssentialMedicalEquipmentItems']),
      []
    ),

    // Private Duty Nursing
    infoPrivateDutyNursingItems: mapWithDefault(
      standardVTCMedicalBenefitsTugoState,
      () => standardVTCMedicalBenefitsTugoState.getIn(['form', 'infoPrivateDutyNursingItems']),
      []
    ),

    // Fracture Treatment
    infoFractureTreatmentItems: mapWithDefault(
      standardVTCMedicalBenefitsTugoState,
      () => standardVTCMedicalBenefitsTugoState.getIn(['form', 'infoFractureTreatmentItems']),
      []
    ),
  })
);

const makeSelectStandardVTCMedicalBenefitsTugoErrors = () => createSelector(
  selectStandardVTCMedicalBenefitsTugo,
  (standardVTCMedicalBenefitsTugoState) => mapWithDefault(
    standardVTCMedicalBenefitsTugoState,
    () => standardVTCMedicalBenefitsTugoState.get('errors'),
    []
  )
);

export {
  makeSelectStandardVTCMedicalBenefitsTugo,
  makeSelectStandardVTCMedicalBenefitsTugoErrors,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Tugo.StandardVTCMedicalBenefits/selectors.js